import React from 'react';
import { Toast as BsToast } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { hideToast } from '@sm/store/toastSlice';

const Toast = () => {
  const message = useSelector(state => state.toast.message);
  const show = useSelector(state => state.toast.show);
  const type = useSelector(state => state.toast.type);

  const dispatch = useDispatch();

  return (
    <BsToast
      bg={ type }
      show={ show }
      onClose={ () => dispatch(hideToast()) }
    >
      <BsToast.Header>
        <strong className="me-auto text-capitalize">{ type === 'danger' ? 'Error' : type }</strong>
        <small>just now</small>
      </BsToast.Header>
      <BsToast.Body>{ message }</BsToast.Body>
    </BsToast>
  );
};

export default Toast;
